import { SegmentDefinition } from '../segment/segment';
import { SkuPredicate } from '../segment/sku-predicate';
import type { BrandSlug } from '../shared/brand-slug';

export type Brand = {
  readonly slug: BrandSlug;
  readonly displayName: string;
};

export function Brand(params: { slug: BrandSlug; displayName: string }): Brand {
  const displayName = params.displayName.trim();
  if (!displayName) {
    throw new Error(`Invalid Brand: empty displayName for slug "${params.slug}"`);
  }
  return {
    slug: params.slug,
    displayName,
  };
}

export namespace Brand {
  export function definition(brand: Brand): SegmentDefinition {
    return SegmentDefinition.of(SkuPredicate.brandIn([brand.slug]));
  }
}
